import { render, staticRenderFns } from "./RuleItem.vue?vue&type=template&id=4b909377&"
import script from "./RuleItem.vue?vue&type=script&lang=js&"
export * from "./RuleItem.vue?vue&type=script&lang=js&"
import style0 from "./RuleItem.vue?vue&type=style&index=0&id=4b909377&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports